export enum RegistrationTypeEnum {
  Quick = 'quick',
  Manual = 'manual',
  Auto = 'auto',
}
